import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "user-details-content" }
const _hoisted_2 = { class: "details-section" }
const _hoisted_3 = { class: "details-section-title" }
const _hoisted_4 = { class: "status-row" }
const _hoisted_5 = { class: "status-label" }
const _hoisted_6 = { class: "status-value" }
const _hoisted_7 = { class: "status-description" }
const _hoisted_8 = { class: "details-section" }
const _hoisted_9 = { class: "details-section-title" }
const _hoisted_10 = { class: "details-list" }
const _hoisted_11 = { class: "detail-row" }
const _hoisted_12 = { class: "detail-label" }
const _hoisted_13 = { class: "detail-value" }
const _hoisted_14 = { class: "detail-row" }
const _hoisted_15 = { class: "detail-label" }
const _hoisted_16 = { class: "detail-value" }
const _hoisted_17 = { class: "detail-row" }
const _hoisted_18 = { class: "detail-label" }
const _hoisted_19 = { class: "detail-value" }
const _hoisted_20 = { class: "detail-row" }
const _hoisted_21 = { class: "detail-label" }
const _hoisted_22 = { class: "detail-value" }
const _hoisted_23 = { class: "detail-row" }
const _hoisted_24 = { class: "detail-label" }
const _hoisted_25 = { class: "detail-value" }
const _hoisted_26 = { class: "detail-row" }
const _hoisted_27 = { class: "detail-label" }
const _hoisted_28 = { class: "detail-value" }
const _hoisted_29 = { class: "details-section" }
const _hoisted_30 = { class: "details-section-title" }
const _hoisted_31 = { class: "details-list" }
const _hoisted_32 = { class: "detail-row" }
const _hoisted_33 = { class: "detail-label" }
const _hoisted_34 = { class: "detail-value" }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "detail-row" }
const _hoisted_37 = { class: "detail-label" }
const _hoisted_38 = { class: "detail-value" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_41 = { class: "detail-label" }
const _hoisted_42 = { class: "detail-value" }
const _hoisted_43 = { class: "details-section" }
const _hoisted_44 = { class: "details-section-title" }
const _hoisted_45 = { class: "details-list" }
const _hoisted_46 = { class: "detail-row" }
const _hoisted_47 = { class: "detail-label" }
const _hoisted_48 = { class: "detail-value" }
const _hoisted_49 = { class: "detail-row" }
const _hoisted_50 = { class: "detail-label" }
const _hoisted_51 = { class: "detail-value" }
const _hoisted_52 = { class: "tab-section" }
const _hoisted_53 = { class: "section-header" }
const _hoisted_54 = { class: "id-text" }
const _hoisted_55 = { class: "tab-section" }
const _hoisted_56 = { class: "section-header" }
const _hoisted_57 = { class: "id-text" }
const _hoisted_58 = { class: "reserve-window" }
const _hoisted_59 = { class: "tab-section" }
const _hoisted_60 = { class: "cards-panel" }
const _hoisted_61 = { class: "section-header compact" }
const _hoisted_62 = {
  key: 0,
  class: "payment-cards-grid"
}
const _hoisted_63 = ["data-default"]
const _hoisted_64 = { class: "card-top-row" }
const _hoisted_65 = { class: "card-brand" }
const _hoisted_66 = { class: "card-number" }
const _hoisted_67 = { class: "card-meta" }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { class: "balance-panel" }
const _hoisted_71 = { class: "section-header compact" }
const _hoisted_72 = { class: "balance-row" }
const _hoisted_73 = { class: "balance-label" }
const _hoisted_74 = { class: "balance-value" }
const _hoisted_75 = {
  key: 0,
  class: "balance-note"
}
const _hoisted_76 = { class: "section-header" }
const _hoisted_77 = ["data-type"]
const _hoisted_78 = { class: "chip-label" }
const _hoisted_79 = { class: "chip-action" }

import { ref, onMounted, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { CopyDocument } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'

import CommonError from '@/components/CommonError.vue'
import Loader from '@/components/Loader.vue'
import { useGolfUsersStore } from '@/store/golf-users'
import { useGolfI18n } from '@/composables/useGolfI18n'
import type {
  GolfUser,
  GolfUserPaymentCard,
  GolfUserReserveSummary,
  GolfUserTripSummary,
  GolfUserTransactionSummary,
} from '@/api/golf'
import { routeNames } from '@/router/route-names'
import { formatDateWithTime } from '@/helpers/date'
import { getUserDetails } from '@/api/user'
import type { UserWithCarsProfiles } from '@/models/user'
import { getUserBalance } from '@/api/finance'

const LS_TAB_KEY = 'golf_user_details_active_tab'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props

const golfStore = useGolfUsersStore()
const router = useRouter()
const { t } = useGolfI18n()
const activeTab = ref(localStorage.getItem(LS_TAB_KEY) || 'user-info')

watch(activeTab, tab => {
  localStorage.setItem(LS_TAB_KEY, tab)
})
const isStatusUpdating = ref(false)
const user = ref<GolfUser | null>(null)
const error = ref<string | null>(null)

const calculatedAge = computed(() => {
  if (!user.value?.date_of_birth) return null
  const birth = new Date(user.value.date_of_birth)
  const now = new Date()
  let age = now.getFullYear() - birth.getFullYear()
  const monthDiff = now.getMonth() - birth.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birth.getDate())) {
    age--
  }
  return age
})

const drivingExperience = computed(() => {
  if (!user.value?.driver_license_issue_date) return null
  const issue = new Date(user.value.driver_license_issue_date)
  const now = new Date()
  const diffMs = now.getTime() - issue.getTime()
  const totalMonths = Math.floor(diffMs / (1000 * 60 * 60 * 24 * 30.44))

  if (totalMonths < 12) {
    return totalMonths + ' months'
  }

  const years = Math.floor(totalMonths / 12)
  const months = totalMonths % 12

  if (months === 0) {
    return years + ' years (' + totalMonths + ' months)'
  }

  return years + ' years and ' + months + ' months (' + totalMonths + ' months)'
})

const recentTrips = computed<GolfUserTripSummary[]>(
  () => user.value?.golf?.recent_trips || []
)
const recentReserves = computed<GolfUserReserveSummary[]>(
  () => user.value?.golf?.recent_reserves || []
)
const recentTransactions = computed<GolfUserTransactionSummary[]>(
  () => user.value?.golf?.recent_transactions || []
)

const sortedPaymentCards = computed<GolfUserPaymentCard[]>(() => {
  if (!user.value?.payment_cards) return []
  return [...user.value.payment_cards].sort((a, b) => {
    if (a.default === b.default) return 0
    return a.default ? -1 : 1
  })
})

const balanceAmount = ref<string | null>(null)
const balanceLoading = ref(false)
const balanceError = ref<string | null>(null)

const formattedBalance = computed(() => formatCurrency(balanceAmount.value || 0))
const isBalanceNegative = computed(
  () => Number(balanceAmount.value || 0) < 0
)

const openTrip = (tripId: string) => {
  router.push({ name: routeNames.golfTripDetails, params: { id: tripId } })
}

const mapStatusType = (status?: string) => {
  switch (status) {
    case 'approved':
    case 'ongoing':
    case 'completed':
      return 'success'
    case 'pending':
      return 'warning'
    case 'cancelled_by_user':
    case 'cancelled_by_admin':
    case 'cancelled_by_system':
      return 'danger'
    default:
      return 'info'
  }
}

const formatTripStatus = (status?: string) => {
  if (!status) return '—'
  const map: Record<string, string> = {
    pending: t('golf.trips.tab_pending'),
    approved: t('golf.trips.tab_approved'),
    ongoing: t('golf.trips.tab_ongoing'),
    on_hold: t('golf.trips.tab_on_hold'),
    completed: t('golf.trips.tab_completed'),
    cancelled_by_user: t('golf.trips.status_cancelled_user'),
    cancelled_by_admin: t('golf.trips.status_cancelled_admin'),
    cancelled_by_system: `${t('golf.trips.tab_cancelled')} (${t('golf.common.system')})`,
  }
  return map[status] || status
}

const formatPricingType = (type?: string) => {
  if (!type) return '—'
  if (type === 'hourly') return t('golf.promo.type_hourly')
  if (type === 'per_minute') return t('golf.promo.type_minute')
  return t('golf.promo.type_daily')
}

const formatCurrency = (amount?: number | string) => {
  if (amount === null || amount === undefined) return '₼0.00'
  const numericAmount = typeof amount === 'string' ? Number(amount) : amount
  if (Number.isNaN(numericAmount)) return '₼0.00'
  return `₼${numericAmount.toFixed(2)}`
}

const formatDateTime = (date?: string) => {
  if (!date) return '—'
  return formatDateWithTime(date, 'MMM dd, yyyy HH:mm')
}

const formatTransactionAction = (action: string) => {
  return action.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}

const loadUser = async () => {
  error.value = null
  const result = await golfStore.fetchUser(props.id)
  if (!result) {
    error.value = golfStore.error || 'Failed to load user'
    return
  }

  const cards = result.payment_cards?.length
    ? result.payment_cards
    : await fetchPaymentCards(result.id)
  user.value = { ...result, payment_cards: cards }
  loadBalance(result.id)
}

const fetchPaymentCards = async (userId: string) => {
  try {
    const response = await getUserDetails(userId)
    const payload = response.data.data as UserWithCarsProfiles | undefined
    return payload?.payment_cards || []
  } catch (e) {
    console.error('Failed to load payment cards for golf user', e)
    return []
  }
}

const loadBalance = async (userId: string) => {
  balanceLoading.value = true
  balanceError.value = null
  try {
    const response = await getUserBalance(userId)
    const payload = response.data.data as { balance?: string } | undefined
    balanceAmount.value = payload?.balance ?? '0'
  } catch (e: any) {
    balanceError.value = e?.message || 'Failed to load balance'
  } finally {
    balanceLoading.value = false
  }
}

const toggleUserStatus = async () => {
  if (!user.value) return

  try {
    isStatusUpdating.value = true
    const newStatus = user.value.status_golf === 'active' ? 'inactive' : 'active'
    await golfStore.updateUserStatus(user.value.id, newStatus)
    await loadUser()
    ElMessage.success(t('golf.users.user_status_updated'))
  } catch (e: any) {
    ElMessage.error(e?.message || t('golf.users.failed_update_status'))
  } finally {
    isStatusUpdating.value = false
  }
}

const copyToClipboard = (value: string) => {
  navigator.clipboard
    .writeText(value)
    .then(() => {
      ElMessage.success(t('golf.trips.id_copied'))
    })
    .catch(() => {
      ElMessage.error(t('golf.trips.failed_copy_id'))
    })
}

onMounted(() => {
  loadUser()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, {
    direction: "vertical",
    class: "container"
  }, {
    default: _withCtx(() => [
      (error.value)
        ? (_openBlock(), _createBlock(CommonError, {
            key: 0,
            errorMessage: error.value,
            onRetryPress: loadUser
          }, null, 8, ["errorMessage"]))
        : (!user.value)
          ? (_openBlock(), _createBlock(Loader, { key: 1 }))
          : (_openBlock(), _createBlock(_component_el_tabs, {
              key: 2,
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event)),
              type: "card",
              class: "user-details-tabs"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('golf.users.user_info'),
                  name: "user-info"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t('golf.common.status')), 1),
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('golf.common.status')), 1),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_el_button, {
                              type: user.value.status_golf === 'active' ? 'danger' : 'success',
                              size: "small",
                              class: "status-btn",
                              loading: isStatusUpdating.value,
                              onClick: toggleUserStatus
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(user.value.status_golf === 'active'
                      ? _ctx.$t('golf.users.block')
                      : _ctx.$t('golf.users.unblock')), 1)
                              ]),
                              _: 1
                            }, 8, ["type", "loading"])
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('golf.users.renter_access_desc')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.$t('golf.users.user_info')), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('golf.common.user')) + " ID", 1),
                            _createElementVNode("span", _hoisted_13, [
                              _createTextVNode(_toDisplayString(user.value.id) + " ", 1),
                              _createVNode(_component_el_icon, {
                                class: "copy-icon",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (copyToClipboard(user.value.id))),
                                title: _ctx.$t('golf.users.copy_user_id')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(CopyDocument))
                                ]),
                                _: 1
                              }, 8, ["title"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('golf.roles.name')), 1),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(user.value.first_name && user.value.last_name
                    ? user.value.first_name + ' ' + user.value.last_name
                    : user.value.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('golf.common.email')), 1),
                            _createElementVNode("span", _hoisted_19, _toDisplayString(user.value.email), 1)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('golf.common.phone')), 1),
                            _createElementVNode("span", _hoisted_22, _toDisplayString(user.value.phone || _ctx.$t('golf.users.not_set')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('golf.common.age')), 1),
                            _createElementVNode("span", _hoisted_25, _toDisplayString(calculatedAge.value !== null
                    ? calculatedAge.value + ' ' + _ctx.$t('golf.users.years')
                    : _ctx.$t('golf.users.not_set')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('golf.common.driving_experience')), 1),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(drivingExperience.value !== null
                    ? drivingExperience.value
                    : _ctx.$t('golf.users.not_set')), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("h4", _hoisted_30, _toDisplayString(_ctx.$t('golf.users.identifications')), 1),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('golf.users.driver_license')), 1),
                            _createElementVNode("span", _hoisted_34, [
                              (user.value.driver_license)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_el_image, {
                                      src: user.value.driver_license,
                                      "preview-src-list": 
                        [
                          user.value.driver_license,
                          user.value.driver_license_backside,
                        ].filter(Boolean) as string[]
                      ,
                                      fit: "cover",
                                      class: "document-image"
                                    }, null, 8, ["src", "preview-src-list"]),
                                    (user.value.driver_license_backside)
                                      ? (_openBlock(), _createBlock(_component_el_image, {
                                          key: 0,
                                          src: user.value.driver_license_backside,
                                          "preview-src-list": 
                        [
                          user.value.driver_license_backside,
                          user.value.driver_license,
                        ].filter(Boolean) as string[]
                      ,
                                          fit: "cover",
                                          class: "document-image"
                                        }, null, 8, ["src", "preview-src-list"]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t('golf.common.not_uploaded')), 1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('golf.users.passport_id')), 1),
                            _createElementVNode("span", _hoisted_38, [
                              (user.value.passport_or_id)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_el_image, {
                                      src: user.value.passport_or_id,
                                      "preview-src-list": 
                        [
                          user.value.passport_or_id,
                          user.value.passport_or_id_backside,
                        ].filter(Boolean) as string[]
                      ,
                                      fit: "cover",
                                      class: "document-image"
                                    }, null, 8, ["src", "preview-src-list"]),
                                    (user.value.passport_or_id_backside)
                                      ? (_openBlock(), _createBlock(_component_el_image, {
                                          key: 0,
                                          src: user.value.passport_or_id_backside,
                                          "preview-src-list": 
                        [
                          user.value.passport_or_id_backside,
                          user.value.passport_or_id,
                        ].filter(Boolean) as string[]
                      ,
                                          fit: "cover",
                                          class: "document-image"
                                        }, null, 8, ["src", "preview-src-list"]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.$t('golf.common.not_uploaded')), 1))
                            ])
                          ]),
                          (user.value.image)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('golf.fleet.profile_photo')), 1),
                                _createElementVNode("div", _hoisted_42, [
                                  _createVNode(_component_el_image, {
                                    src: user.value.image,
                                    "preview-src-list": [user.value.image],
                                    fit: "cover",
                                    class: "user-image"
                                  }, null, 8, ["src", "preview-src-list"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("h4", _hoisted_44, _toDisplayString(_ctx.$t('golf.users.golf_statistics')), 1),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t('golf.users.total_trips')), 1),
                            _createElementVNode("span", _hoisted_48, _toDisplayString(user.value.trips_count), 1)
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t('golf.users.last_trip_date')), 1),
                            _createElementVNode("span", _hoisted_51, _toDisplayString(user.value.last_trip_date || _ctx.$t('golf.users.no_trips_yet')), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('golf.trips.title'),
                  name: "trips",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('golf.users.recent_trips')), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t('golf.users.latest_bookings_desc')), 1)
                        ]),
                        (recentTrips.value.length)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              type: "info",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(recentTrips.value.length) + " " + _toDisplayString(_ctx.$t('golf.users.loaded')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      (recentTrips.value.length)
                        ? (_openBlock(), _createBlock(_component_el_table, {
                            key: 0,
                            data: recentTrips.value,
                            class: "tab-table",
                            stripe: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.users.trip'),
                                "min-width": "160"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createElementVNode("span", _hoisted_54, "#" + _toDisplayString(row.id), 1),
                                  _createVNode(_component_el_button, {
                                    link: "",
                                    type: "primary",
                                    size: "small",
                                    onClick: ($event: any) => (openTrip(row.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('golf.fleet.view')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.common.status'),
                                "min-width": "130"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createVNode(_component_el_tag, {
                                    type: mapStatusType(row.status),
                                    effect: "light"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(formatTripStatus(row.status)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["type"])
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.users.pricing'),
                                "min-width": "120"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(formatPricingType(row.pricing_type)), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.users.base'),
                                "min-width": "100",
                                align: "right"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(formatCurrency(row.base_rate_amount)), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.trips.trip_total'),
                                "min-width": "110",
                                align: "right"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createElementVNode("strong", null, _toDisplayString(formatCurrency(row.total_amount)), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.common.created'),
                                "min-width": "180"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(formatDateTime(row.created_at)), 1)
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }, 8, ["data"]))
                        : (_openBlock(), _createBlock(_component_el_empty, {
                            key: 1,
                            description: _ctx.$t('golf.users.no_trips_recorded')
                          }, null, 8, ["description"]))
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('golf.reserves.title'),
                  name: "reservations",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('golf.users.latest_reserves')), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t('golf.users.latest_bookings_desc')), 1)
                        ]),
                        (recentReserves.value.length)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              type: "success",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(recentReserves.value.length) + " " + _toDisplayString(_ctx.$t('golf.users.loaded')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      (recentReserves.value.length)
                        ? (_openBlock(), _createBlock(_component_el_table, {
                            key: 0,
                            data: recentReserves.value,
                            class: "tab-table",
                            stripe: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.users.reserve'),
                                "min-width": "140"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createElementVNode("span", _hoisted_57, "#" + _toDisplayString(row.id), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.common.status'),
                                "min-width": "130"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createVNode(_component_el_tag, {
                                    type: mapStatusType(row.status),
                                    effect: "light"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(formatTripStatus(row.status)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["type"])
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.users.pricing'),
                                "min-width": "120"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(formatPricingType(row.pricing_type)), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.users.reserved_window'),
                                "min-width": "220"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("span", null, _toDisplayString(formatDateTime(row.reserved_from)), 1),
                                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "window-sep" }, "→", -1)),
                                    _createElementVNode("span", null, _toDisplayString(formatDateTime(row.reserved_to)), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.common.amount'),
                                "min-width": "110",
                                align: "right"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(formatCurrency(row.total_amount)), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.common.created'),
                                "min-width": "180"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(formatDateTime(row.created_at)), 1)
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }, 8, ["data"]))
                        : (_openBlock(), _createBlock(_component_el_empty, {
                            key: 1,
                            description: _ctx.$t('golf.users.no_reserves_found')
                          }, null, 8, ["description"]))
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_tab_pane, {
                  label: _ctx.$t('golf.trips.trip_finance'),
                  name: "finance",
                  lazy: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('golf.users.payment_cards')), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('golf.users.linked_cards_desc')), 1)
                          ]),
                          (sortedPaymentCards.value.length)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 0,
                                type: "info",
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(sortedPaymentCards.value.length) + " " + _toDisplayString(_ctx.$t('golf.users.on_file')), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        (sortedPaymentCards.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedPaymentCards.value, (card) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: card.id,
                                  class: "payment-card-tile",
                                  "data-default": card.default
                                }, [
                                  _createElementVNode("div", _hoisted_64, [
                                    _createElementVNode("span", _hoisted_65, _toDisplayString(card.brand), 1),
                                    (card.default)
                                      ? (_openBlock(), _createBlock(_component_el_tag, {
                                          key: 0,
                                          type: "success",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                                            _createTextVNode(" Default ")
                                          ])),
                                          _: 1,
                                          __: [3]
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_66, _toDisplayString(card.masked_pan), 1),
                                  _createElementVNode("div", _hoisted_67, [
                                    (card.card_uid)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_68, "UID: " + _toDisplayString(card.card_uid), 1))
                                      : _createCommentVNode("", true),
                                    (card.created_at)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_69, " Added: " + _toDisplayString(formatDateTime(card.created_at)), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 8, _hoisted_63))
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock(_component_el_empty, {
                              key: 1,
                              description: _ctx.$t('golf.users.no_cards_on_file')
                            }, null, 8, ["description"]))
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", null, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('golf.users.balance')), 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('golf.users.wallet_state_desc')), 1)
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["balance-card", { negative: isBalanceNegative.value }])
                        }, [
                          (balanceLoading.value)
                            ? (_openBlock(), _createBlock(_component_el_skeleton, {
                                key: 0,
                                rows: 1,
                                animated: ""
                              }))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_72, [
                                  _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.$t('golf.users.current_balance')), 1),
                                  _createElementVNode("span", _hoisted_74, _toDisplayString(formattedBalance.value), 1)
                                ]),
                                (isBalanceNegative.value)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_75, _toDisplayString(_ctx.$t('golf.users.outstanding_amount_warning')), 1))
                                  : _createCommentVNode("", true),
                                (balanceError.value)
                                  ? (_openBlock(), _createBlock(_component_el_alert, {
                                      key: 1,
                                      type: "error",
                                      closable: false,
                                      description: balanceError.value,
                                      "show-icon": "",
                                      class: "balance-alert"
                                    }, null, 8, ["description"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('golf.financial.payment_activity')), 1),
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t('golf.financial.recent_deposit_service_desc')), 1)
                        ]),
                        (recentTransactions.value.length)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              type: "warning",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(recentTransactions.value.length) + " " + _toDisplayString(_ctx.$t('golf.users.loaded')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      (recentTransactions.value.length)
                        ? (_openBlock(), _createBlock(_component_el_table, {
                            key: 0,
                            data: recentTransactions.value,
                            class: "tab-table",
                            stripe: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.users.operation'),
                                "min-width": "160"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createElementVNode("div", {
                                    class: "operation-chip",
                                    "data-type": row.type
                                  }, [
                                    _createElementVNode("span", _hoisted_78, _toDisplayString(row.type), 1),
                                    _createElementVNode("span", _hoisted_79, _toDisplayString(formatTransactionAction(row.action)), 1)
                                  ], 8, _hoisted_77)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.common.amount'),
                                "min-width": "110",
                                align: "right"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createElementVNode("strong", null, _toDisplayString(formatCurrency(row.amount)), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.users.description'),
                                "min-width": "200"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(row.description || '—'), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _ctx.$t('golf.common.created'),
                                "min-width": "180"
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(formatDateTime(row.created_at)), 1)
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }, 8, ["data"]))
                        : (_openBlock(), _createBlock(_component_el_empty, {
                            key: 1,
                            description: _ctx.$t('golf.users.no_financial_operations')
                          }, null, 8, ["description"]))
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["modelValue"]))
    ]),
    _: 1
  }))
}
}

})